<template>
  <div class="redeem-get-away">
    <div class="redeem-get-away__header">
      <h2 class="redeem-get-away__header__title">
        <DynLang by-key="redeem-get-away-header-title" />
      </h2>
    </div>

    <div class="redeem-get-away__info">
      <p>
        <DynLang by-key="redeem-get-away-info-1" />
      </p>
      <p>
        <DynLang by-key="redeem-get-away-info-2" />
      </p>
    </div>

    <h3 class="redeem-get-away__header__subtitle">
      <DynLang by-key="redeem-get-away-subtitle" />
    </h3>


    <div class="redeem-get-away__info">
      <span class="redeem-get-away__info__highlight">
        <DynLang by-key="redeem-get-away-step-1-header" />
      </span>
      <span>
        <DynLang by-key="redeem-get-away-step-1-body" />

        <span class="ml-text">
          <SplButton
            variant="link"
            @click="openFindVoucherCode"
          >
            <DynLang by-key="here" />
          </SplButton>
        </span>
      </span>
    </div>

    <Modal
      v-model="findVoucherCodeOpen"
      content-full-height
    >
      <div class="redeem-get-away__redeem-voucher-img">
        <img src="~/assets/images/redeem-voucher.png">
      </div>
    </Modal>

    <div class="redeem-get-away__info">
      <p>
        <span class="redeem-get-away__info__highlight">
          <DynLang by-key="redeem-get-away-step-2-header" />
        </span>
        <span>
          <DynLang by-key="redeem-get-away-step-2-body" />
        </span>
      </p>
      <p class="redeem-get-away__info">
        <DynLang by-key="redeem-get-away-step-2-body-extra" />
      </p>
    </div>

    <div
      class="redeem-get-away__faq"
    >
      <div
        v-for="(faqItem, i) in faqItems"
        :key="`faq-${i}`"
        class="redeem-get-away__faq__item"
      >
        <CollapsableSection
          :separator="i < (faqItems.length - 1)"
          :title="faqItem.header"
          :html="faqItem.body"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import SplButton from '~/core/components/shared/form/SplButton.vue'
import CollapsableSection from '~/core/components/shared/CollapsableSection.vue'
import Modal from '~/core/components/shared/form/Modal.vue'

import RedeemGetAwayFAQRepository from '~/core/ts/repository/RedeemGetAwayFAQRepository'

export default defineNuxtComponent({
  components: {
    SplButton,
    CollapsableSection,
    Modal,
  },
  setup() {
    const findVoucherCodeOpen = ref(false)
    function openFindVoucherCode() {
      findVoucherCodeOpen.value = true
    }

    const faqItems = RedeemGetAwayFAQRepository.get()

    return {
      findVoucherCodeOpen,
      openFindVoucherCode,

      faqItems,
    }
  },
})
</script>

<style lang="scss" scoped>
.redeem-get-away{
  &__header {
    @apply py-8;

    &__title {
      @apply text-3xl;
      @apply font-bold;
      @apply text-spl-primary-dark;

      @apply text-center;
    }

    &__subtitle {
      @apply text-2xl;
      @apply text-spl-primary-dark;

      @apply text-center;
      @apply py-4;
    }
  }

  &__redeem-voucher-img {
    img {
      width: 100%;
    }

    @screen lg {
      @apply flex;
      @apply justify-center;

      img {
        width: 80%;
      }
    }
  }

  &__info {
    @apply py-1;

    &__highlight {
      @apply mr-1;
      @apply font-bold;
    }
  }

  &__faq {
    @apply py-8;
  }
}
</style>
